import { CommandProcessor } from '@/api/CommandProcessor'
import { Command } from 'lime-js'
import { BOT_DOMAIN } from '../settings'

export class ConfigurationsCommandProcessor {
    static getConfigGateway(identifier: string): Command {

    return CommandProcessor.processCommand({
      method: 'get',
      to: `postmaster@${BOT_DOMAIN}`,
      uri: `lime://postmaster@gw.msging.net/configuration/gateways/content-filters/${identifier}@${BOT_DOMAIN}`,
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/api/ConfigurationsCommandProcessor.ts